<template>
  <div class="user">
    <el-form size="small" ref="form" :model="form" label-width="150px">
      <el-form-item label="是否开启" prop="is_couponss">
        <el-switch v-model="form.status"></el-switch>
      </el-form-item>
      
      <el-form-item label="咨询热线" prop="hotline">
        <el-input v-model="form.hotline" placeholder="输入咨询热线" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="邮箱" prop="email">
        <el-input v-model="form.email" placeholder="输入邮箱" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="工作时间" prop="working">
        <el-input v-model="form.working" placeholder="输入工作时间" class="max-w460"></el-input>
      </el-form-item>
      
      <!-- 添加客服二维码上传 -->
      <el-form-item label="客服二维码" prop="qrcode">
        <div class="qrcode-upload" @click="openQrcodeUpload">
          <img v-if="form.qrcode_file_path" :src="form.qrcode_file_path" alt="客服二维码" class="qrcode-image" />
          <div v-else class="upload-placeholder">
            <i class="el-icon-plus"></i>
            <div>上传二维码</div>
          </div>
        </div>
        <p class="gray">建议尺寸：200x200px，支持 JPG、PNG 格式</p>
      </el-form-item>
    </el-form>
    
    <!--提交-->
    <div class="common-button-wrapper">
      <el-button size="small" type="primary" @click="onSubmit" :disabled="loading">保存</el-button>
    </div>

    <!--上传图片组件-->
    <Upload v-if="isProductUpload" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Consultation_dlApi from '@/api/consultation_dl.js';
import Upload from '@/components/file/Upload';
import draggable from 'vuedraggable';

export default {
  components: {
    Upload,
    draggable
  },
  data() {
    return {
      form: {
        hotline: '',
        status: false,
        email: '',
        working: '',
        qrcode_file_path: '', // 二维码图片路径
        qrcode_image_id: 0    // 二维码图片ID
      },
      setting: [],
      loading: false,
      isProductUpload: false,
      uploadType: '' // 用于区分上传类型
    };
  },
  created() {
    /*获取列表*/
    this.getSetting();
  },
  methods: {
    /*获取设置*/
    getSetting() {
      let self = this;
      let Params = {};
      Consultation_dlApi.getSetting(Params, true)
        .then(data => {
          self.loading = false;
          console.log(data)
          if(data.data.vars.values!='[]'){
            self.form = data.data.vars.values;
          }
        })
        .catch(error => {});
    },
    
    /*点击保存*/
    onSubmit() {
      let self = this;
      let params = self.form;
      self.loading = true;
      Consultation_dlApi.saveSetting(params, true)
        .then(data => {
          self.loading = false;
          if (data.code == 1) {
            self.$message({
              message: '恭喜你，保存成功',
              type: 'success'
            });
            self.getSetting();
          } else {
            self.loading = false;
          }
        })
        .catch(error => {
          self.loading = false;
        });
    },

    /*打开二维码上传*/
    openQrcodeUpload() {
      this.uploadType = 'qrcode';
      this.isProductUpload = true;
    },

    /*获取上传的图片*/
    returnProductImgsFunc(e) {
      if (e != null && e.length > 0) {
        if (this.uploadType === 'qrcode') {
          // 处理二维码上传
          this.form.qrcode_file_path = e[0].file_path;
          this.form.qrcode_image_id = e[0].file_id;
        }
      }
      this.isProductUpload = false;
      this.uploadType = '';
    }
  }
};
</script>

<style>
.draggable-list {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}
.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 二维码上传样式 */
.qrcode-upload {
  width: 150px;
  height: 150px;
  border: 2px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  transition: border-color 0.3s;
}

.qrcode-upload:hover {
  border-color: #409eff;
}

.qrcode-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-placeholder {
  text-align: center;
  color: #8c939d;
}

.upload-placeholder i {
  font-size: 28px;
  margin-bottom: 8px;
}

.upload-placeholder div {
  font-size: 12px;
}

.gray {
  color: #999;
  font-size: 12px;
  margin-top: 8px;
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/consultation_dl/setting/getSetting.vue